/**
 * 광고 배너/게시물 데이터 (프론트 하드코딩)
 *
 * 백엔드에 "Castar Ads" 카테고리/홈페이지 URL 필드가 아직 없어서,
 * 우선 프론트 상수로 광고 콘텐츠를 관리한다.
 * 추후 백엔드 연동 시 이 파일을 API 응답으로 교체하면 된다.
 *
 * @typedef {Object} AdItem
 * @property {string} id             - 광고 고유 id (라우트 /community/ads/:id 및 /community/:postId 에 사용)
 * @property {string} advertiser     - 광고주명 (배지/작성자 표기)
 * @property {string} badge          - 카드 상단에 붙는 굵은 강조 문구 (예: "50% 특별 할인")
 * @property {string} title          - 광고 제목
 * @property {string} subtitle       - 카드/리스트용 부제 (오렌지 색)
 * @property {string} [bannerImage]  - 대시보드 세로형 사이드 배너(AdSideBanner)에 쓰는 이미지 (3:4 권장)
 * @property {string} [gridImage]    - 배우찾기 그리드 카드(AdGridCard variant="talent")에 쓰는 이미지 (1:1 권장)
 * @property {string[]} images       - 상세 페이지에 세로로 나열하는 이미지 목록 (9:16 권장, 없으면 그라디언트 placeholder)
 * @property {string} description    - 상세 페이지 본문 (줄바꿈 포함)
 * @property {string} [homepageUrl]  - "홈페이지로 이동" 버튼 URL
 * @property {string} [instagramUrl] - "인스타그램" 버튼 URL
 * @property {boolean} [enabled]     - 수동 노출 토글. false면 기간 안이어도 무조건 숨김 (기본값 true)
 * @property {string} startDate      - 노출 시작일 (YYYY-MM-DD, 이 날짜부터 노출)
 * @property {string} endDate        - 노출 종료일 (YYYY-MM-DD, 이 날짜까지 노출, 지나면 자동 숨김)
 * @property {number} viewCount      - 리스트에 보여줄 조회수(더미)
 * @property {number} likeCount      - 리스트에 보여줄 좋아요 수(더미)
 * @property {string} postedAt       - 게시일 (YYYY-MM-DD)
 */

/**
 * 실제 집행 중인 광고가 생기면 여기에 추가한다.
 * 스튜디오 클락션 항목은 디자인 확인용 테스트 데이터였으므로 배포 전 비워둠.
 *
 * 추가 예시:
 * {
 *   id: 'unique-slug',
 *   advertiser: '광고주명',
 *   badge: '카드 상단 강조 문구',
 *   title: '광고 제목',
 *   subtitle: '카드/리스트용 부제',
 *   bannerImage: '/assets/images/ads/xxx-banner.png',
 *   gridImage: '/assets/images/ads/xxx-grid.png',
 *   images: ['/assets/images/ads/xxx-1.png'],
 *   description: '상세 페이지 본문',
 *   homepageUrl: 'https://...',
 *   instagramUrl: 'https://instagram.com/...',
 *   enabled: true,
 *   startDate: '2026-01-01',
 *   endDate: '2026-01-31',
 *   viewCount: 0,
 *   likeCount: 0,
 *   postedAt: '2026-01-01',
 * }
 *
 * @type {AdItem[]}
 */
export const ADS = [
  // TODO: 디자인 확인용 임시 데이터 — 배포 전 실제 광고 데이터로 교체하거나 비울 것
  {
    id: 'studio-klaxon-2026',
    advertiser: '스튜디오 클락션',
    badge: '프로필 촬영 이벤트 오픈',
    title: '캐스타 X 스튜디오 클락션 50% 특별 할인 프로모션',
    subtitle: '스튜디오 클락션과 함께하는 50% 특별 할인 프로모션, 지금 만나보세요!',
    bannerImage: '/assets/images/ads/studio-klaxon-1.png',
    gridImage: '/assets/images/ads/studio-klaxon-1.png',
    images: [
      '/assets/images/ads/studio-klaxon-1.png',
      '/assets/images/ads/studio-klaxon-2.png',
    ],
    description:
      '안녕하세요. 스튜디오 클락션입니다.\n\n' +
      '저희 스튜디오 클락션은 광고 촬영경력 10년의 포토그래퍼와\n' +
      '배우출신 포토그래퍼가 함께하는 인물화보 전문 스튜디오로서\n' +
      '현장에서 눈에 띌 수 있는 프로필을 만들어드릴 자신이 있습니다!\n\n' +
      '저도 배우활동 당시 많은 오디션과 촬영기회를 얻었던 사람으로서\n' +
      '남다른 애정을 갖고 있기에 2026년 캐스타와 함께 할인 프로모션을 진행하게 되었습니다.\n\n' +
      "감각적인 프로필을 만들고 싶으시다면, 이번기회에 합리적인 가격으로\n'스튜디오 클락션'과 함께 만족스러운 프로필 촬영해보시는 건 어떨까요?\n\n" +
      '- 혜택대상 : 캐스타를 이용하는 누구나! (예약시 "캐스타 회원입니다" 필수 언급)\n' +
      '- 할인혜택 : 정가 10만원 → 할인가 5만원 (1컨셉당 보정본 2장, 원본데이터 제공)\n' +
      '- 이벤트기간 : 2026년 8월 31일까지\n' +
      '- 주소 : 서울시 광진구 중곡동 천호대로 623-1 B1\n\n' +
      '촬영물은 인스타그램 @studio_klaxon_ 참고해주시고\n' +
      '언제든 궁금한 사항은 카카오톡채널 @스튜디오클락션 으로 문의주세요!\n' +
      '촬영중에는 답변이 조금 늦을 수도 있습니다!!\n\n' +
      '🍎많은 관심부탁드리며 배우분들의 건승을 기원합니다',
    homepageUrl: 'https://pf.kakao.com/_studioklaxon',
    instagramUrl: 'https://www.instagram.com/studio_klaxon_',
    enabled: true,
    startDate: '2026-07-01',
    endDate: '2026-12-31',
    viewCount: 62,
    likeCount: 3,
    postedAt: '2026-07-01',
  },
];

function isAdActive(ad, today = new Date()) {
  if (ad.enabled === false) return false;
  const start = ad.startDate ? new Date(ad.startDate) : null;
  const end = ad.endDate ? new Date(`${ad.endDate}T23:59:59`) : null;
  if (start && today < start) return false;
  if (end && today > end) return false;
  return true;
}

/** 지금 노출 기간 안에 있는 광고만 반환 (종료된 광고는 자동 제외) */
export function getActiveAds() {
  const now = new Date();
  return ADS.filter((ad) => isAdActive(ad, now));
}

export function getAdById(id) {
  return ADS.find((ad) => ad.id === id) || null;
}

/**
 * 진행 중인 광고 중 하나를 순환 노출한다.
 * 같은 렌더 사이클(같은 slotKey) 안에서는 항상 같은 광고가 나오도록,
 * 날짜+슬롯 이름을 시드로 결정적으로 고른다 — 그래야 새로고침해도
 * 화면 안에서 광고가 뒤죽박죽 안 바뀌고, 대신 날짜가 바뀌면 자연스럽게 로테이션된다.
 * @param {string} slotKey - 배너가 노출되는 위치 구분자 (예: 'talents-grid')
 */
export function getRotatingAd(slotKey = 'default') {
  return pickRotatingAd(getActiveAds(), slotKey);
}

/**
 * 주어진 목록에서 오늘 이 자리에 보일 광고를 고른다.
 * 서버에서 받은 목록에도 같은 규칙을 쓰려고 고르는 부분만 떼어 놓았다.
 */
export function pickRotatingAd(ads, slotKey = 'default') {
  if (!Array.isArray(ads) || ads.length === 0) return null;
  const dayIndex = Math.floor(Date.now() / 86400000);
  let hash = 0;
  for (let i = 0; i < slotKey.length; i++) hash = (hash * 31 + slotKey.charCodeAt(i)) >>> 0;
  return ads[(dayIndex + hash) % ads.length];
}
